import { gsap } from 'gsap';

export default () => {
	const header = document.querySelector('.header');

	const isMobile = { Android: function() {
		return navigator.userAgent.match(/Android/i);
	}, BlackBerry: function() {
		return navigator.userAgent.match(/BlackBerry/i);
	}, iOS: function() {
		return navigator.userAgent.match(/iPhone|iPad|iPod/i);
	}, Opera: function() {
		return navigator.userAgent.match(/Opera Mini/i);
	}, Windows: function() {
		return navigator.userAgent.match(/IEMobile/i);
	}, any: function() {
		return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
	} };

	if (!header) return;

	const submenuBtns = document.querySelectorAll('.js-open-submenu');

	submenuBtns.forEach(function(button) {
		
		if (!isMobile.any()) {
			button.addEventListener('mouseenter', openSubMenu);
			button.addEventListener('mouseleave', closeSubMenu);
		}
		else {
			
		}

		function openSubMenu(e) {
			button.classList.add('header__nav-item--opened');
			header.classList.add('header--opened');

			const innerImages = button.querySelectorAll('.submenu__product-img');
			innerImages.forEach(function(image) {
				if (!image.classList.contains('loaded')) {
					image.src = image.dataset.src;
					image.style.opacity = '1';
					image.classList.add('loaded');
				}
			});
		}

		function closeSubMenu(e) {
			e.preventDefault();
			if (button.classList.contains('header__nav-item--opened')) {
				button.classList.remove('header__nav-item--opened');
				header.classList.remove('header--opened');
			}
		}
	});


	const overlay = document.querySelector('.page-overlay');
	if (overlay) {
		overlay.addEventListener('click', (e) => {
			header.classList.remove('header--opened');
			const activeItem = document.querySelector('.header__nav-item--opened');
			if (activeItem) {
				activeItem.classList.remove('header__nav-item--opened');
			}
		});
	}
	


	const expandButtons = document.querySelectorAll('.js-expand-nav');
	if (expandButtons.length) {
		expandButtons.forEach(function(btn) {
			btn.addEventListener('click', (e) => {
				if (isMobile.any()) {
					e.preventDefault();
				}
				
				const li = btn.closest('.header__nav-item')
				if (li) {
					const submenu = li.querySelector('.submenu');
					const isOpened = li.classList.toggle('header__nav-item--opened');

					if (submenu) {
						gsap.to(submenu, {
							height: isOpened ? 'auto' : 0,
							duration: 0.5
						});
					}
				}
			});
		});
	}


	const popupButtons  = document.querySelectorAll('.submenu__nav-title[data-menu-id] .submenu__nav-icon');
	const popupCloseButtons  = document.querySelectorAll('.js-close');
	const menuPopups  = document.querySelectorAll('.header__nav-third[data-menu-id]');
	popupButtons.forEach(function(btn) {
		btn.addEventListener('click', (e) => {
			e.preventDefault();
			
			const targetPopupId = btn.closest('.submenu__nav-title').dataset.menuId;
			const targetPopup = document.querySelector(`.header__nav-third[data-menu-id='${targetPopupId}']`);

			if (targetPopup) {
				targetPopup.classList.add('is-visible');
			}
		});
	});

	popupCloseButtons.forEach(function(button) {
		button.addEventListener('click', (e) => {
			e.preventDefault();
			let parent = button.closest('.header__nav-third')
			if (parent) {
				parent.classList.remove('is-visible');
			}
		});
	});

	const backBtns = document.querySelectorAll('.js-submenu-back');
	if (backBtns.length) {
		backBtns.forEach(function(btn) {
			btn.addEventListener('click', (e) => {
				e.preventDefault();

				const parent = btn.closest('.header__nav-item');

				const isOpened = parent.classList.toggle('header__nav-item--opened');
				if (isOpened) {
					header.classList.add('header--opened');
				}
				else {
					header.classList.remove('header--opened');
				}
			});
		});
	}

	const burger = document.querySelector('.burger');

	if (burger) {
		burger.addEventListener('click', (e) => {
			e.preventDefault();
		
			document.body.classList.toggle('is-menu-opened');
			burger.classList.toggle('burger--active');
		});
	}


	setTimeout(function(){
		const searchBtn = document.querySelector('.snize-sticky-searchbox');
		const headerBtn = document.querySelector('.js-open-search');
		
		if (searchBtn && headerBtn) {
			headerBtn.addEventListener('click', (e) => {
				e.preventDefault();
				searchBtn.click();
			});
			
			const input = document.querySelector('.snize-input-style');
			if (input) {
				input.setAttribute('placeholder', 'Search...');
			}


			// modal inject popular
			const modal = document.querySelector('.snize-modal');
			const popular = document.querySelector('.popular');

			if (modal && popular) {
				modal.appendChild(popular)
				const buttons = document.querySelectorAll('.popular__item');
				buttons.forEach(function(button) {
					button.addEventListener('click', (e) => {
						e.preventDefault();
						
						let searchText = button.innerText;
						input.value = searchText;
						input.focus();
						input.click();
					});
				});
			}
		}
	}, 2000);


	let accBtn = document.querySelector('.js-acc-menu');
	let accMenu = document.querySelector('.account-menu');

	if (accBtn && accMenu) {
		accBtn.addEventListener('click', (e) => {
			accMenu.classList.toggle('account-menu--visible');
		});
		
		document.addEventListener('click', (e) => {
			if (accMenu.classList.contains('account-menu--visible') && !e.target.closest('.account-menu') && !e.target.closest('.js-acc-menu')) {
				accMenu.classList.remove('account-menu--visible');
			}
		});
	}
};